import React, { useEffect } from "react";

export const BOT_TYPES = Object.freeze({
	VENDOR_CHAT: {
		"bot-id": "d34aa04acc3d86c3f9e73c1328ff0437",
        "group-id": "54",
        "widget": "true",
        "audio": "false",
        "voice": "false",
        "open": "false",
        "tooltip": "Ciao, se hai bisogno di aiuto io sono qui!",
        "z-index": "9999"
	}, 
	CHAT: {
		"bot-id": "9816a5cd46d08efb4506f54481279b40",
		"widget": "true",
		"open": "false",
		"restore-open": "false",
		"tooltip": "Ciao, se hai bisogno di aiuto io sono qui!",
		"z-index": "9999",
		"audio": "false",
		"voice": "false",
		"dhi": "false",
		"transparent": "false",
		"avatar-delayed": "false",
		"avatar-wait": "false",
		"allow-switch-interface": "false",
		"stomp": "true"
	},
	VOICE: {
		"bot-id": "9816a5cd46d08efb4506f54481279b40",
		"widget": "true",
		"open": "false",
		"restore-open": "false",
		"tooltip": "Ciao, se hai bisogno di aiuto io sono qui!",
		"z-index": "9999",
		"audio": "true",
		"voice": "true",
		"dhi": "true",
		"transparent": "true",
		"avatar-delayed": "true",
		"avatar-wait": "true",
		"allow-switch-interface": "true",
		"stomp": "true"
	}
});

export default function AlghoBot({ botType }) {
	useEffect(() => {
		
		// MAPPA IL BOT DINAMICAMENTE IN BASE AL TIPO
        const tag = document.createElement("algho-viewer");

		Object.keys(botType).forEach(k => {
			tag.setAttribute(k, botType[k]);
		});
		
		document.body.appendChild(tag);

        const script = document.createElement("script");
        script.setAttribute("id", "algho-viewer-module");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("defer", "defer");
        script.setAttribute("charset", "UTF-8");
        script.setAttribute("src", "https://virtualassistant.alghoncloud.com/algho-viewer.min.js");
        document.body.appendChild(script);

        // Cleanup dello script e dell'elemento algho-viewer quando il componente viene smontato
        return () => {
            document.body.removeChild(tag);
            document.body.removeChild(script);
        };
    }, [botType]);

    return null;  // Non renderizza nulla visivamente, si occupa solo dello script.
}